/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Max_Wpm_LabelInputs */

const en_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Words Per Minute (WPM)`)
};

const fr_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal de mots par minute (WPM)`)
};

const de_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Wörter pro Minute (WPM)`)
};

const it_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di parole al minuto (WPM)`)
};

const ru_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальная скорость печати (слов в минуту)`)
};

const es_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de palabras por minuto (WPM)`)
};

const zh_cn2_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟最大字数 (WPM)`)
};

const ja_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分あたりの最大単語数（WPM）`)
};

const hi_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम शब्द प्रति मिनट (WPM)`)
};

const pt_pt2_edit_event_group_max_wpm_label = /** @type {(inputs: Edit_Event_Group_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de palavras por minuto (PPM)`)
};

/**
* | output |
* | --- |
* | "Max Words Per Minute (WPM)" |
*
* @param {Edit_Event_Group_Max_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_max_wpm_label = /** @type {((inputs?: Edit_Event_Group_Max_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Max_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_max_wpm_label(inputs)
	if (locale === "de") return de_edit_event_group_max_wpm_label(inputs)
	if (locale === "it") return it_edit_event_group_max_wpm_label(inputs)
	if (locale === "ru") return ru_edit_event_group_max_wpm_label(inputs)
	if (locale === "es") return es_edit_event_group_max_wpm_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_max_wpm_label(inputs)
	if (locale === "ja") return ja_edit_event_group_max_wpm_label(inputs)
	if (locale === "hi") return hi_edit_event_group_max_wpm_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_max_wpm_label(inputs)
	return en_edit_event_group_max_wpm_label(inputs)
});